import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, MenuItem, Select, FormControl } from "@mui/material";
import { FaFilter } from "react-icons/fa";
import * as _ser from "../../../_redux/_services/ClientsSlice";
import ClientJobsCard from "../../../components/ClientJobsCard/ClientJobsCard";
import Pagination from "../../../components/DynamicTable/Pagination";
import { resetSelectedJobPosting, setSelectedJobPosting } from "../../../_redux/SelectedJobPostingSlice";
import { updateNextPath } from "../../../_redux/SelectedNextPath";
import { toggleSidebar } from "../../../_redux/Uislice";
import "./ClientJobs.css";
import JobpostingDetailsTabs from "../../JobPostings_New_UI/JobpostingDetails/JobpostingDetailsTabs/JobpostingDetailsTabs";

const PageSize = 6;

const ClientJobs = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const clientJobsData = useSelector((state) => state.GetClientJobs.data);
  const jobs = clientJobsData?.jobOpenings || [];
  const totalCount = clientJobsData?.totalCount || 0;

  const endClientsData = useSelector((state) => state.GetEndClients.data);
  const endClients = endClientsData?.endClients;

  const [currentPage, setCurrentPage] = useState(1);
  const [filterValue, setFilterValue] = useState("All");
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [isResetTabs, setIsResetTabs] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(
        _ser.getClientJobsAsync(
          id,
          { limit: PageSize, offset: currentPage },
          filterValue,
        ),
      );
    }
  }, [dispatch, id, currentPage, filterValue]);

  useEffect(() => {
    if (id) {
      dispatch(_ser.getEndClientsAsync(id));
    }
  }, [id]);

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
    setCurrentPage(1);
  };

  const { storedJobPostingId, aditionalState } = useSelector((state) => state.SelectedJobPosting);

  useEffect(() => {
    if (!storedJobPostingId) {
      setShowJobDetails(false);
    } else if (storedJobPostingId && aditionalState) {
      dispatch(updateNextPath(aditionalState));
      setShowJobDetails(true);
      navigate(
        `/ats/layout/clients/jobs/${id}?clientJobId=${storedJobPostingId}`
      );
    }
  }, [storedJobPostingId, aditionalState, navigate]);

  const handleJobCardClick = (id, jobCode, jobTitle) => {
    dispatch(resetSelectedJobPosting());
    setIsResetTabs(true);
    dispatch(setSelectedJobPosting({ storedJobPostingId: id, storedJobCode: jobCode, aditionalState: `${jobTitle} (${jobCode})` }));
    dispatch(updateNextPath(`${jobTitle} (${jobCode})`));
    setShowJobDetails(true);
  };

  const onReceivePropsHandler = (_status, type) => {
    if (type === "close" || _status === "close") {
      setShowJobDetails(false);
      dispatch(updateNextPath("null"));
      dispatch(toggleSidebar(false));
      navigate(location.pathname);
    } else if (_status === "deleted") {
      setShowJobDetails(false);
      dispatch(updateNextPath("null"));
      dispatch(toggleSidebar(false));
      dispatch(
        _ser.getClientJobsAsync(
          id,
          { limit: PageSize, offset: currentPage },
          filterValue,
        ),
      );
    } else if (_status === "changeAppliant") {
      dispatch(_ser.getClientJobsAsync(id, { limit: PageSize, offset: currentPage }, filterValue,));
    }
  };

  return (
    <Box className="client-jobs-page">
      {!showJobDetails ? (
        <>
          {/* Filter Section */}
          <Box className="filter-section">
            <Box className="filter-left">
              <Box className="filter-icon">
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/FilterIcon.svg"}
                  alt="FilterIcon"
                />
              </Box>
              <Typography className="clientJobs-filter-label">
                Filter by End Client :
              </Typography>
              <FormControl className="filter-dropdown" size="medium">
                <Select
                  sx={{ width: "150px", height: "32px" }}
                  value={filterValue}
                  onChange={handleFilterChange}
                  displayEmpty
                >
                  <MenuItem value="All">All</MenuItem>
                  {endClients?.map((client) => (
                    <MenuItem key={client.id} value={client.id}>
                      {client.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box className="filter-right">
              <Typography className="showing-jobs">
                Showing {totalCount} jobs
              </Typography>
            </Box>
          </Box>

          {/* Jobs Grid */}
          <Box className="jobs-grid">
            {jobs.length > 0 ? (
              jobs.map((job) => (
                <ClientJobsCard
                  key={job.jobDetails.id}
                  job={job}
                  onClick={() =>
                    handleJobCardClick(job.jobDetails.id, job.jobDetails.jobCode, job.jobDetails.jobTitle)
                  }
                />
              ))
            ) : (
              <div className="detail-card-empty No-client-jobs">
                <img
                  src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                  alt="No data"
                />
                No jobs found
              </div>
            )}
          </Box>

          {/* Pagination */}
          {totalCount > PageSize && (
            <Box display="flex" justifyContent="flex-end" mt={3} mb={3}>
              <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={totalCount}
                pageSize={PageSize}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </Box>
          )}
        </>
      ) : (
        <Box className="clientJob-details-container">
          <JobpostingDetailsTabs
            onResetTabs={isResetTabs}
            onReceiveProps={(status, type) => {
              onReceivePropsHandler(status, type);
            }}
            moduleType="client"
          />
        </Box>
      )}
    </Box>
  );
};

export default ClientJobs;
